var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlimitedMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "58px",
    viewBox: "0 0 128 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-Upgrade-&-Payment-\\uD83D\\uDCB3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upgrade",
    transform: "translate(-124.000000, -127.000000)",
    stroke: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Upgrade/Unlimited-Messages",
    transform: "translate(113.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(13.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mail",
    transform: "translate(47.000000, 0.000000)",
    fill: "#CCCCCC",
    fillRule: "nonzero",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.0043936,0 L8.06146812,0 C3.61134168,0.00506490293 0.00506448879,3.611637 0,8.06212733 L0,47.8245393 C0.00506448879,52.2750297 3.61134168,55.8816018 8.06146812,55.8866667 L69.0042324,55.8866667 C73.4543588,55.8816018 77.060636,52.2750297 77.0657005,47.8245393 L77.0657005,8.06212733 C77.0608135,3.61162629 73.4545306,0.00497640359 69.0043936,0 Z M54.6711033,27.9323688 L73.8412745,12.8855369 L73.8412745,46.5429836 L54.6711033,27.9323688 Z M8.06146812,3.22485093 L69.0042324,3.22485093 C71.6743156,3.22787214 73.8380923,5.39182577 73.8411132,8.06212733 L73.8411132,8.78610637 L42.8189716,33.1366333 C40.4850918,34.9588021 37.2099873,34.9561417 34.8790704,33.1301836 L3.22458725,8.77997915 L3.22458725,8.06212733 C3.22760821,5.39182577 5.3913849,3.22787214 8.06146812,3.22485093 Z M22.9651879,28.0336292 L3.22458725,46.6079643 L3.22458725,12.8484511 L22.9651879,28.0336292 Z M69.0043936,52.6618157 L8.06146812,52.6618157 C6.3824471,52.6608385 4.82398598,51.7893277 3.94399266,50.3592722 L25.554209,30.026587 L32.9033658,35.6797507 C36.4005961,38.4117068 41.3088489,38.4104434 44.8046724,35.6766871 L52.1114259,29.9427409 L73.1300917,50.3463728 C72.2516178,51.7837713 70.6888794,52.6608184 69.0043936,52.6618157 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 8.89333333,
    x2: 34,
    y2: 8.89333333,
    id: "Line-2",
    strokeWidth: 5,
    strokeLinecap: "round",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 22.8933333,
    x2: 34,
    y2: 22.8933333,
    id: "Line-2-Copy",
    strokeWidth: 5,
    strokeLinecap: "round",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 36.8933333,
    x2: 34,
    y2: 36.8933333,
    id: "Line-2-Copy-2",
    strokeWidth: 5,
    strokeLinecap: "round",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlimitedMessages);
export default __webpack_public_path__ + "static/media/unlimited_messages.638c75f446744cb51d1dc4a60bce1016.svg";
export { ForwardRef as ReactComponent };